/**
 * Client entry point for the `allocateOrderDocumentNumber` Cloud Function —
 * the ONLY way a work order or an order-linked delivery gets its number
 * (`WWO-2026-0042`, `WDO-2026-0042A`). The number is derived server-side from
 * the order's OC serial and the per-order ordinal is bumped in a transaction;
 * never compose one of these strings on the client.
 *
 * Manual deliveries with no order do not come here — they stay on the `DO`
 * counter via allocateSequenceNumber('DO').
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type OrderDocumentKind = 'WO' | 'DO';

const callable = httpsCallable<
  { orderId: string; kind: OrderDocumentKind },
  { number: string; ordinal: number }
>(functions, 'allocateOrderDocumentNumber');

export const allocateOrderDocumentNumber = async (
  orderId: string,
  kind: OrderDocumentKind,
): Promise<string> => {
  const result = await callable({ orderId, kind });
  return result.data.number;
};
